

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Meta } from '@/decorators/meta.ts';
import { defaultMeta } from '@/utils/meta';
import TopNavbar from '@/components/TopNavbar.vue';
import Footer from '@/components/Footer.vue';
import GoldAlpaca from '@/components/GoldAlpaca.vue';
import GlobalSnackbar from '@/components/GlobalSnackbar.vue';
import TransactionResultPopup from '@/components/TransactionResultPopup.vue';
import TransferPopup from '@/components/TransferPopup.vue';
import { detectAccountChange, detectChainChange, loadWeb3} from '@/utils/web3';

@Component({
  components: {
    TopNavbar,
    TransactionResultPopup,
    TransferPopup,
    Footer,
    GoldAlpaca,
    GlobalSnackbar,
  },
  metaInfo: defaultMeta,
})
export default class App extends Vue {
  @Meta({
    metaInfo: defaultMeta,
  })
  public meta!: string;
  // public async beforeCreate() {
  //   // detectAccountChange(this);
  //   // detectChainChange(this);
  //   await loadWeb3(this);
  // }

  get account() {
    return this.$store.getters.getAccount;
  }

  public metaInfo() {
    return defaultMeta;
  }
}
